import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export const usePurgeCustomerBo = () => {
  const queryClient = useQueryClient();

  const purgeCustomer = async (customerId: number) => {
    const response = await Axios.delete(
      `${DELETE_URL(customerId.toString()).purgeCustomerBo}`
    );
    // 204: finished. 202: a large organization is still being removed in the
    // background.
    return response.status;
  };

  return useMutation<number, AxiosError<BaseError>, number>(
    (customerId: number) => purgeCustomer(customerId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customersBo']);
      },
      useErrorBoundary: false
    }
  );
};
